import React from "react";
import styles from "./Stepper.module.scss";

const Stepper = ({ currentStep, steps, className = "" }) => {
  return (
    <div className={`${styles.stepper} ${className}`}>
      {steps.map((stepLabel, index) => {
        const stepNumber = index + 1;
        const isActive = stepNumber === currentStep;
        const isCompleted = stepNumber < currentStep;
        const isUpcoming = stepNumber > currentStep;

        return (
          <div key={index} className={styles.stepContainer}>
            <div className={styles.stepWrapper}>
              {/* Numéro du step */}
              <div
                className={`${styles.stepNumber} ${isActive ? styles.active : ""
                  } ${isCompleted ? styles.completed : ""} ${isUpcoming ? styles.upcoming : ""
                  }`}
              >
                {stepNumber}
              </div>

              {/* Libellé du step */}
              <div
                className={`${styles.stepLabel} ${isActive ? styles.active : ""
                  } ${isCompleted ? styles.completed : ""}`}
              >
                {stepLabel}
              </div>
            </div>

            {/* Ligne de connexion (sauf pour le dernier step) */}
            {index < steps.length - 1 && (
              <div
                className={`${styles.connector} ${isCompleted ? styles.completed : ""
                  }`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Stepper;
